export default class ServiceBooking{

	constructor(serviceId, serviceName,  pickup , date, guests, origin, destination, flightCompany, flightNumber, observations, price, currency, adultsQty, chdAges){
		this.serviceId = serviceId;
		this.serviceName= serviceName;
		this.pickup = pickup;
		this.date = date;
		this.guests = guests;
		this.pickupPlace = origin;
		this.dropoffPlace = destination;
		this.flightCompany = flightCompany;
		this.flightNumber = flightNumber;
		this.observations = observations;
		this.price = price;
		this.currency = currency;
		this.adultsQty = adultsQty;
		this.chdAges = chdAges;
	}

}



// WEBPACK FOOTER //
// ./src/model/ServiceBooking.js